import { render, staticRenderFns } from "./CodesAssureursCabinet.vue?vue&type=template&id=88dc4cba&scoped=true&"
import script from "./CodesAssureursCabinet.vue?vue&type=script&lang=js&"
export * from "./CodesAssureursCabinet.vue?vue&type=script&lang=js&"
import style0 from "./CodesAssureursCabinet.vue?vue&type=style&index=0&id=88dc4cba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88dc4cba",
  null
  
)

export default component.exports